import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RegisterClosureTimeSelectorFormPageRoutingModule } from './register-closure-time-selector-form-routing.module';

import { RegisterClosureTimeSelectorFormPage } from './register-closure-time-selector-form.page';


import { SharedModule} from '../../shared.module';

// import { AmazingTimePickerModule } from 'amazing-time-picker';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RegisterClosureTimeSelectorFormPageRoutingModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [RegisterClosureTimeSelectorFormPage],
  exports: [
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
})
export class RegisterClosureTimeSelectorFormPageModule {}
